import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Button, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar
} from "../../../../_metronic/_partials/controls";
import { changeStatusProjectStatus, deleteProject, getAllProjects } from "../../../../api/project";
import { alertError, alertSuccess } from '../../../../utils/logger';
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog';
import Table, {
    buttonsStyle,
    dateFormatter,
} from "../../../components/tables/table";

export default function ProjectsPage() {
    const history = useHistory();
    const user = useSelector((store) => store.authentication?.user, shallowEqual);
    const [refresh, setRefresh] = useState(false)
    const [project, setProject] = useState(null);
    const [data, setData] = useState([])
    const [filteredData, setFilteredData] = useState([])
    const [openConfirmDialog, setOpenConfirmDialog] = useState(null)

    useEffect(() => {
        getAllProjects()
            .then((projectsRes) => {
                const result = projectsRes.data.map(project => ({
                    title: project.title,
                    technology: project.technology.title?.en,
                    developmentStatus: project.developmentStatus.title?.en,
                    seller: project.seller.fullName,
                    createdAt: project.createdAt,
                    active: project.active,
                    id: project._id
                }));
                setData(result);
                setFilteredData(result);
                setRefresh(false);
            })
            .catch((error) => {
                alertError({
                    error: error,
                    customMessage: "Error fetching projects.",
                });
            });
    }, [refresh]);

    function buttonFormatter(cell) {
        const elem = data.find((item) => item.id === cell);
        return (
            <>
                <Tooltip title="Watch">
                    <Button
                        style={buttonsStyle}
                        size="small"
                        onClick={() => {
                            history.push("/edit-project/" + elem.id)
                        }}
                    >
                        <EditIcon />
                    </Button>
                </Tooltip>
                {user?.role === "admin" && (
                    <>
                        <Tooltip title={elem?.active ? "Deactivate" : "Activate"}>
                            <Button
                                style={buttonsStyle}
                                size="small"
                                onClick={() => {
                                    setProject(elem);
                                    setOpenConfirmDialog(1);
                                }}
                            >
                                {elem?.active ? (
                                    <ToggleOffIcon />
                                ) : (
                                    <ToggleOnIcon style={{ color: "red" }} />
                                )}
                            </Button>
                        </Tooltip>
                        <Tooltip title="Delete">
                            <Button
                                style={buttonsStyle}
                                size="small"
                                onClick={() => {
                                    setProject(elem);
                                    setOpenConfirmDialog(2);
                                }}
                            >
                                <DeleteIcon />
                            </Button>
                        </Tooltip>
                    </>
                )}
            </>
        );
    }

    const columns = [
        { dataField: "title", text: "Project name", sort: true },
        { dataField: "technology", text: "Technology", sort: true },
        { dataField: "developmentStatus", text: "Development Status", sort: true },
        { dataField: "seller", text: "Seller", sort: true },
        {
            dataField: "createdAt",
            text: "Created at",
            formatter: dateFormatter,
            sort: true,
        },
        { dataField: "id", text: "", formatter: buttonFormatter },
    ];


    return (
        <Card>
            <CardHeader title="Projects list">
                <CardHeaderToolbar>
                    <button
                        type="button"
                        className="btn btn-primary text-white"
                        onClick={() => history.push("/edit-project")}
                    >
                        Add new
                    </button>
                </CardHeaderToolbar>
            </CardHeader>
            <CardBody>
                <Table data={filteredData} columns={columns} />

                <ConfirmDialog
                    title={`Are you sure you want to ${project?.active ? "deactivate" : "activate"} this project?`}
                    open={openConfirmDialog === 1}
                    setOpen={setOpenConfirmDialog}
                    onConfirm={() => {
                        changeStatusProjectStatus(project.id, !project?.active)
                            .then((res) => {
                                alertSuccess({
                                    title: `${project?.active ? "Deactivate!" : "Activate!"
                                        }`,
                                    customMessage: `Project ${project?.active ? "deactivate" : "activate"
                                        } successfully`,
                                });
                                setRefresh(true);
                            })
                            .catch((error) => {
                                alertError({
                                    error: error,
                                    customMessage: `Could not ${project?.active ? "deactivate" : "activate"
                                        } the project.`,
                                });
                            });
                    }}
                />

                <ConfirmDialog
                    title={'Are you sure you want to remove this project?'}
                    open={openConfirmDialog === 2}
                    setOpen={setOpenConfirmDialog}
                    onConfirm={() => {
                        deleteProject(project.id)
                            .then((res) => {
                                alertSuccess({
                                    title: 'Deleted!',
                                    customMessage: 'Project removed successfully.',
                                });
                                setRefresh(true);
                            })
                            .catch((error) => {
                                alertError({
                                    error: error,
                                    customMessage: 'Could not remove project.',
                                });
                            });
                    }}
                />
            </CardBody>
        </Card>
    );
}